<div *ngIf="!isLoggedIn">
  <p>You must first log in and verify your account to claim a
    bounty</p>
  <a href="/login" class="ui orange button">
    Log in
  </a>
</div>

<div *ngIf="isLoggedIn && !isVerified">
  <p>You must first verify your osu account before you can claim
    a bounty. You can do this from your profile (by entering
    your osu username, clicking save and then following the
    instructions)</p>
  <a href="/profile" target="_blank" class="ui orange button">
    Go to profile
  </a>
</div>

<div *ngIf="isLoggedIn && isVerified && !success" class="ui inverted form">
  <div class="field">
    <p>
      Your osu username is: {{user.osu_username}} (this must be the
      same user who set the score(s) in your evidence).
    </p>
    <p>
      You must upload any replay files using a hosting service, and post links to any files here.
    </p>
  </div>
  <div class="field">
    <label>
      Enter links to your score(s) or other evidence of completion
    </label>
    <textarea rows="2" placeholder="Enter evidence here..." [(ngModel)]="evidence"></textarea>
  </div>
  <div *ngIf="errors.length" class="ui inverted negative message">
    <div class="header">
      There were some errors with your submission
    </div>
    <ul class="list">
      <li *ngFor="let error of errors">{{error}}</li>
    </ul>
  </div>
  <button class="ui primary button" type="submit" [disabled]="submitting" [class.loading]="submitting" (click)="submitClaim()">
    Submit Claim
  </button>
</div>
